import React, { useCallback, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { moveToTrash } from "~/store/actions/actions.tasks.jsx";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import {
  hasCollaborativePermissionsOnProject,
  makeIsLoggedUserOwnerOrProjectLeadForProject,
} from "~/store/selectors/selector.users.jsx";
import TaskPageContext from "./context/TaskPageContext.jsx";
import TaskOptions from "./TaskOptions.jsx";

const TaskOptionsContainer = ({
  taskId,
  projectId,
  onChooseRecurringTask,
  onCopyPermalinkToClipboard,
  onMoveCopyToProject,
  onTrash,
  onDuplicate,
  onAddReminder,
}) => {
  const dispatch = useDispatch();
  const getIsLoggedUserOwnerOrProjectLeaderSelector = useMemo(makeIsLoggedUserOwnerOrProjectLeadForProject, []);
  const isLoggedUserElevatedPermissions = useSelector((state) =>
    hasCollaborativePermissionsOnProject(state, projectId)
  );
  const isLoggedUserOwnerOrProjectLeader = useSelector((state) =>
    getIsLoggedUserOwnerOrProjectLeaderSelector(state, projectId)
  );
  const { handleClose } = useContext(TaskPageContext);
  const recurringTasksEnabled = useSelector((state) => getRawConfigOption(state, `recurring_tasks_enabled`));

  const handleOpenRecurringTask = useCallback(() => {
    if (typeof onChooseRecurringTask === "function") {
      onChooseRecurringTask();
    }
  }, [onChooseRecurringTask]);

  const handleTaskTrash = useCallback(
    (trashTracking) => {
      typeof handleClose === "function" && handleClose();
      typeof onTrash === "function" && onTrash();
      dispatch(moveToTrash(taskId, trashTracking));
    },
    [dispatch, handleClose, taskId, onTrash]
  );

  return (
    <TaskOptions
      taskId={taskId}
      projectId={projectId}
      onMakeRecurring={handleOpenRecurringTask}
      onTrash={handleTaskTrash}
      showAccessLogsLink={isLoggedUserOwnerOrProjectLeader}
      canEdit={isLoggedUserElevatedPermissions}
      onCopyPermalinkToClipboard={onCopyPermalinkToClipboard}
      onMoveCopyToProject={onMoveCopyToProject}
      onDuplicate={onDuplicate}
      recurringTasksEnabled={recurringTasksEnabled}
      onAddReminder={onAddReminder}
    />
  );
};

TaskOptionsContainer.propTypes = {
  taskId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  onCopyPermalinkToClipboard: PropTypes.func,
  onChooseRecurringTask: PropTypes.func,
  onMoveCopyToProject: PropTypes.func,
  onDuplicate: PropTypes.func,
  onTrash: PropTypes.func,
  onAddReminder: PropTypes.func,
};

export default TaskOptionsContainer;
